export default __webpack_public_path__ + "static/media/rocket.3418a79f.svg";